export function Footer() {
  return (
    <footer className="border-t-[3px] border-ink bg-crate text-cream">
      <div className="mx-auto grid max-w-[1200px] gap-8 px-4 py-10 sm:grid-cols-[1.2fr_1fr] sm:px-6">
        <div>
          <p className="font-slam text-5xl uppercase leading-none">SonarImg</p>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-cream/70">
            Print-lab upscaler. The model is ESRGAN. It runs in this tab. If
            the tab dies, the picture dies with it. We never see it.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-3 font-mono text-[11px] uppercase leading-relaxed tracking-[0.08em] text-cream/70">
          <p>JPG / PNG / WEBP</p>
          <p>Max 10 MB</p>
          <p>2× 4× 8×</p>
          <p>No account</p>
          <p>No upload</p>
          <p>No invoice</p>
        </div>
      </div>
      <div className="hazard h-2.5 border-t-[3px] border-ink" />
    </footer>
  );
}
